module.exports = __webpack_public_path__ + "img/couples-001.c0f3fca8.jpg";